import crudHandlers from "./_crud";

export default (state, action) => {
    const { type } = action;
    switch (type) {
        case 'LOAD_LOCATION_MANAGER_SUBGROUPS':
            return {
                ...state,
                entities: action.payload
            }
        default:

            state = crudHandlers(state, action, 'location_manager_subgroup')

            return state
    }
}
